import React, { Component } from "react";
import { connect } from "react-redux";

import { setMenuState } from "../actions/siteActions";

class MenuButton extends Component {
  setMenuState = () => {
    const { site } = this.props;
    this.props.setMenuState(!site.menu.open);
  };
  render() {
    const { site } = this.props;
    return (
      <button className="menuButton" onClick={() => this.setMenuState()}>
        <img src={process.env.PUBLIC_URL + "/img/menu.png"} alt="menu" />
        {/*!site.menu.open ? (
          <img src={process.env.PUBLIC_URL + "/img/menu.png"} alt="menu" />
        ) : (
          <img src={process.env.PUBLIC_URL + "/img/menu_close.png"} alt="menu" />
        )*/}
      </button>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, { setMenuState })(MenuButton);
